import React from 'react'

const Spinning = () => (
  <div className="loading-thoughts">
    <div className="loading-spinner">
    💖
    </div>
  </div>
)

export default Spinning;